import { RouteType } from '@/main/menu/constants';

import { NAME as name } from './constants';
import { AccountReceivable } from './AccountReceivable';

export const menu = {
	name,
	orderAlphabetically: false,
	list: [
		{ name: 'AccountReceivables', route: AccountReceivable.name, routeType: RouteType.name },
	],
};
